var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"height":"600"}},[_c('h2',[_vm._v("Income Statement Report")]),_vm._v("\n\n To be done...\n ")])
}]

export { render, staticRenderFns }